"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        autocomplete: function (props) { return ({
            '& .MuiAutocomplete-inputRoot': {
                flexWrap: props.open ? 'wrap' : 'nowrap',
            },
            '& .MuiAutocomplete-tag': {
                color: theme.palette.primary.dark,
                fontSize: 13,
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            '& .MuiInputBase-root': {
                overflow: 'hidden',
                height: props.open ? 'auto' : 54,
                paddingTop: 15,
                paddingLeft: 0,
                position: props.open && !props.positionStatic ? 'absolute' : 'relative',
            },
            '& .MuiFormLabel-root': {
                top: 10,
            },
            '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
                transform: 'translate(2px, -2px) scale(0.75)',
            },
        }); },
        chips: {
            color: theme.palette.primary.dark,
            paddingLeft: 6,
            paddingRight: 6,
            height: 24,
            textTransform: 'uppercase',
            fontSize: utils_1.textSizeMap.text.small,
            fontWeight: utils_1.textWeightMap['extra-bold'],
            margin: '6px 3px',
            '& .MuiChip-deleteIcon': {
                color: theme.palette.primary.dark,
            },
        },
        menuItem: {
            '&:hover': {
                backgroundColor: '#d1e0ec',
            },
            width: '100%',
        },
    });
});
